import $ from "jquery"

const contact = () => {
  const init = () => {
    // date()
  }

  const dateField = ".mi-ContactContainer__Form #form-field-date"

  const date = () => {
    $(() => {
      // eslint-disable-next-line no-console
      console.log($(dateField))
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }

      today = yyyy + '-' + mm + '-' + dd;

      $(dateField).attr('min', today)
    })
  }



  init()
}

contact()
